import { ABSENCE_TYPES } from '../../../constants';
import { mergeContiguousSegments, packLanes } from '../../../utils/planning';
import { assignmentTarget } from '../shared/assignmentTarget';
import { overlapsWindow, plannedHours, windowIndexes } from '../shared/lanes';

const ABS_COLOR_MAP = Object.fromEntries((ABSENCE_TYPES || []).map((t) => [t.id, t.color]));
const ABS_LABEL_MAP = Object.fromEntries((ABSENCE_TYPES || []).map((t) => [t.id, t.label]));

function assignmentSegment(a, appState, firstIso, lastIso) {
  const { client, brique } = assignmentTarget(appState.clients, a.briqueId);
  if (!client) return null;
  const { h, totalH } = plannedHours(appState.devs, a);
  return {
    affId: a.id,
    briqueId: a.briqueId,
    ...windowIndexes(a, firstIso, lastIso),
    h,
    totalH,
    clientId: client.id,
    clientName: client.nom,
    brique,
    realStart: a.debut,
    realEnd: a.fin,
    isAbs: false,
  };
}

function absenceSegment(a, firstIso, lastIso) {
  const type = a.type || 'vacances';
  return {
    affId: `abs_${a.id}`,
    ...windowIndexes(a, firstIso, lastIso),
    realStart: a.debut,
    realEnd: a.fin,
    isAbs: true,
    absType: type,
    absColor: ABS_COLOR_MAP[type] || '#cdc9c2',
    absLabel: ABS_LABEL_MAP[type] || 'Absence',
    absObj: a,
    affIds: [],
    leftAffId: null,
    rightAffId: null,
  };
}

/* Barres style Float pour la vue dev : fusion contiguë (même brique + h/jour), couleur par client,
   plus les absences ; le tout réparti en couloirs. */
export function memberSegments({ affsDev, devAbs, appState, firstIso, lastIso }) {
  const raw = affsDev
    .filter((a) => overlapsWindow(a, firstIso, lastIso))
    .map((a) => assignmentSegment(a, appState, firstIso, lastIso))
    .filter(Boolean);
  const affSegs = mergeContiguousSegments(raw, (r) => `${r.briqueId}|${r.h}`);
  const absSegs = (devAbs || [])
    .filter((a) => overlapsWindow(a, firstIso, lastIso))
    .map((a) => absenceSegment(a, firstIso, lastIso));
  return packLanes([...affSegs, ...absSegs]);
}
